import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBoxMark = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M36.2586 10.2154L14.4014 32.2821C13.946 32.7418 13.3284 33 12.6844 33C12.0405 33 11.4229 32.7418 10.9674 32.2821L3.68173 24.9266C3.23935 24.4641 2.99456 23.8448 3.00009 23.2019C3.00563 22.5591 3.26104 21.9441 3.71131 21.4895C4.16159 21.0349 4.77071 20.7771 5.40747 20.7715C6.04423 20.7659 6.65769 21.013 7.11573 21.4596L12.6844 27.0817L32.8246 6.74852C33.0486 6.51435 33.3166 6.32756 33.6129 6.19906C33.9092 6.07056 34.2279 6.00292 34.5503 6.00009C34.8728 5.99726 35.1926 6.0593 35.491 6.18258C35.7895 6.30586 36.0607 6.48792 36.2887 6.71813C36.5167 6.94834 36.697 7.2221 36.8192 7.52342C36.9413 7.82474 37.0027 8.1476 36.9999 8.47316C36.9971 8.79871 36.9301 9.12045 36.8028 9.41958C36.6755 9.71872 36.4905 9.98927 36.2586 10.2154Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckBoxMark);
export default ForwardRef;
